import { useState } from "react";
import { getMailService } from "../service/getMailService";

export const useGetMailCliente = () => {
  const [mail, setMail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async (idComprobante) => {
    setLoading(true);
    setError(null);

    try {
      const data = await getMailService(idComprobante);
      setMail(data);

      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    execute,
    mail,
    loading,
    error,
  };
};
